import {
    authenticationService
} from "@/services/AuthenticationService";


export const checkAccessController = (moduleID, access_level_id) => {
    //Check in Secure Storage if user has access, will return true or false

    let modules = []
    // let routesModule = 0
    let roleID = null
    // console.log('moduleID :', moduleID);
    // if (moduleID != null) {
    // routesModule = moduleID
    // }
    // console.log('authenticationService12 :', authenticationService);
    if (authenticationService.get("USINFO")) {
        roleID = authenticationService.get("USINFO").role_id
    }
    // console.log('roleID :', roleID);

    if (roleID == 1 || roleID == 2 || roleID == 3 || roleID == 8 || roleID == 9) {
        return true
    }
    else {



        // the role is not the 5 roles then 
        // if (authenticationService.get("module_list")) {
        //   // console.log('authenticationService.get("module_list") :', authenticationService.get("module_list"));
        //   modules = authenticationService.get("module_list")

        //   // console.log('modules :', modules);
        //   // console.log('routesModule :', routesModule);
        //   if (modules.indexOf(moduleID) > -1) {
        //     // console.log('true :', true);
        //     return roleArray, true
        //   }
        //   else {
        //     // console.log('false :', false);
        //     return roleArray, false
        //   }
        // }

        //get all the list of modules user has permissions to

        // return the error
        // the role is not the 5 roles then 
        if (authenticationService.get("module_list")) {
            // console.log('authenticationService.get("module_list") :', authenticationService.get("module_list"));
            modules = authenticationService.get("module_list")

            // console.log('modules :', modules);
            // console.log('routesModule :', routesModule);
            if (modules.length > 0) {
                if (modules.indexOf(moduleID) > -1) {
                    // console.log('true :', true);
                    // console.log('roleArray :', roleArray);
                    return true
                }
                else {
                    // console.log('false :', false);
                    return false
                }
            } else {
                return false
            }
        }
    }

}

export const checkParentId = function (Nav) {
    let roleID = null
    if (authenticationService.get("USINFO")) {
        roleID = authenticationService.get("USINFO").role_id
    }

    if (roleID == 1 || roleID == 2 || roleID == 3 || roleID == 8 || roleID == 9) {
        return true;
    }

    let list = authenticationService.get("module_categories_list");
    list = [...new Set(list)];
    if (Nav.hasOwnProperty('id')) {
        let parentId = Nav.id;
        if (list.indexOf(parentId) > -1) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/helper/AccessControl.js